import {
    CATEGORY_PRIMARY_SENTINEL,
    CATEGORY_SECONDARY_SENTINEL,
    DEFAULT_CATEGORY_BORDER_COLOR,
} from "@constants/index";

// Construit un résolveur de couleurs qui remplace les sentinelles
// (__primary__ / __secondary__) par les couleurs réelles du design général,
// avec fallback. Partagé entre les réglages catégorie/produit et les previews.
// `generalDesign` est typé via le type global GeneralDesignType (plus de cast
// `unknown`/interface locale) ; les `?.` couvrent un design absent/incomplet.
export function makeResolveColor(
    generalDesign: GeneralDesignType,
    primaryFallback: string = DEFAULT_CATEGORY_BORDER_COLOR,
    secondaryFallback = "#FFFFFF"
): (color: string) => string {
    const primaryColor = generalDesign?.colors?.[0]?.content ?? primaryFallback;
    const secondaryColor =
        generalDesign?.colors?.[1]?.content ?? secondaryFallback;

    return (color: string): string => {
        if (color === CATEGORY_PRIMARY_SENTINEL) return primaryColor;
        if (color === CATEGORY_SECONDARY_SENTINEL) return secondaryColor;
        return color;
    };
}
